import { Box } from '@mui/material';
import { FormTitleBox, LoadingSkeleton, PaginationTable } from '../../../common/components';
import QualityCommentsDataTable from './components/QualityCommentsDataTable';
import QualityCommentsFilters from './components/QualityCommentsFilters';
import QualityCommentDialog from './components/QualityCommentDialog';
import { useQualityCommentsTable } from './hooks/useQualityCommentsTable';
import FactCheckIcon from '@mui/icons-material/FactCheck';

const QualityCommentsTable = () => {
  const {
    data,
    isLoading,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    searchTerm,
    allotments,
    lots,
    selectedAllotment,
    selectedLot,
    statusFilter,
    dialogOpen,
    editMode,
    selectedComment,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
    handleSelectAllotment,
    handleSelectLot,
    handleSelectStatusFilter,
    handleOpenDialog,
    handleCloseDialog,
    handleInputChange,
    handleSave,
    handleToggleCompleted,
  } = useQualityCommentsTable();

  if (isLoading) {
    return <LoadingSkeleton />;
  }

  return (
    <Box>
      <FormTitleBox
        title="Seguimiento | Comentarios de Calidad"
        showButton={false}
        showSearch={true}
        searchLabel="Buscar comentario por tarea, lote o loteo"
        searchValue={searchTerm}
        onSearchChange={handleSearch}
        searchSize="medium"
        buttonIcon={FactCheckIcon}
      />

      <QualityCommentsFilters
        allotments={allotments}
        lots={lots}
        selectedAllotment={selectedAllotment}
        selectedLot={selectedLot}
        statusFilter={statusFilter}
        onSelectAllotment={handleSelectAllotment}
        onSelectLot={handleSelectLot}
        onSelectStatusFilter={handleSelectStatusFilter}
      />

      <QualityCommentsDataTable
        data={data}
        isLoading={isLoading}
        onEdit={handleOpenDialog}
        onToggleCompleted={handleToggleCompleted}
        LoadingComponent={LoadingSkeleton}
      />

      <PaginationTable
        totalPages={totalPages}
        totalCount={totalCount}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <QualityCommentDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        editMode={editMode}
        comment={selectedComment}
        onInputChange={handleInputChange}
        onSave={handleSave}
      />
    </Box>
  );
};

export default QualityCommentsTable;
